import axios, { AxiosRequestConfig } from 'axios';
import { apiVersionResponseInterceptors } from '../interceptors/api-version.interceptor';
import { authRequestInterceptors, authResponseErrorInterceptors, authResponseSuccessInterceptors } from '../interceptors/auth.interceptor';
import { notificationResponseErrorInterceptors, notificationResponseSuccessInterceptors } from '../interceptors/notification.interceptor';
import { paramsRequestInterceptors } from '../interceptors/params.interceptor';

const baseConfig: AxiosRequestConfig = {
   baseURL: import.meta.env.VITE_APP_API_BASE_URL,
};

const api = axios.create(baseConfig);

const cacheFirstConfig: AxiosRequestConfig = {
   headers: {
      'Cache-Control': 'force-cache',
   },
};

//request interceptors
api.interceptors.request.use(authRequestInterceptors);
api.interceptors.request.use(paramsRequestInterceptors);
//response interceptors
api.interceptors.response.use(authResponseSuccessInterceptors, authResponseErrorInterceptors);
api.interceptors.response.use(notificationResponseSuccessInterceptors, notificationResponseErrorInterceptors);
api.interceptors.response.use(apiVersionResponseInterceptors);

export { api, cacheFirstConfig };
